module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "background-color": "rgb(255,255,255)"
    },
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "selectionFrame",
    staticStyle: {
      "left": "0px",
      "top": "0px",
      "z-index": "1002"
    },
    attrs: {
      "id": "frame2",
      "xmlns": "http://www.w3.org/1999/xhtml"
    }
  }, [_c('img', {
    staticClass: "item",
    staticStyle: {
      "width": "900px",
      "height": "675px"
    },
    attrs: {
      "alt": "",
      "id": "item2",
      "src": "CI_B33C08A9-E72B-4314-B3F0-995204602D17.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55412344","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page005.vue
// module id = 69
// module chunks = 0